// extracted by mini-css-extract-plugin
module.exports = {"input-root":"Input_input-root__WTqa3","xs":"Input_xs__2c1vb","sm":"Input_sm__GSAZS","normal":"Input_normal__3uxmu","lg":"Input_lg__3VFUw"};